import _classCallCheck from "/Volumes/DustedRepos/htb/htb-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/Volumes/DustedRepos/htb/htb-gatsby/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _slicedToArray from "/Volumes/DustedRepos/htb/htb-gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _regeneratorRuntime from "/Volumes/DustedRepos/htb/htb-gatsby/node_modules/@babel/runtime/regenerator/index.js";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import adaptRequest from "./requestAdapter";
import adaptResponse from "./responseAdapter";
import request from "./request";

function _get(engineKey, path, params) {
  var query = Object.entries(Object.assign({
    engine_key: engineKey
  }, params)).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        paramName = _ref2[0],
        paramValue = _ref2[1];

    return "".concat(paramName, "=").concat(encodeURIComponent(paramValue));
  }).join("&");
  return fetch("https://search-api.swiftype.com/api/v1/public/".concat(path, "?").concat(query), {
    method: "GET",
    credentials: "include"
  });
}

var SiteSearchAPIConnector = /*#__PURE__*/function () {
  function SiteSearchAPIConnector(_ref3) {
    var documentType = _ref3.documentType,
        engineKey = _ref3.engineKey,
        _ref3$beforeSearchCal = _ref3.beforeSearchCall,
        beforeSearchCall = _ref3$beforeSearchCal === void 0 ? function (queryOptions, next) {
      return next(queryOptions);
    } : _ref3$beforeSearchCal,
        _ref3$beforeAutocompl = _ref3.beforeAutocompleteResultsCall,
        beforeAutocompleteResultsCall = _ref3$beforeAutocompl === void 0 ? function (queryOptions, next) {
      return next(queryOptions);
    } : _ref3$beforeAutocompl;

    _classCallCheck(this, SiteSearchAPIConnector);

    this.documentType = documentType;
    this.engineKey = engineKey;
    this.beforeSearchCall = beforeSearchCall;
    this.beforeAutocompleteResultsCall = beforeAutocompleteResultsCall;
    this.request = request.bind(this, engineKey);
    this._get = _get.bind(this, engineKey);
  }

  _createClass(SiteSearchAPIConnector, [{
    key: "onResultClick",
    value: function onResultClick(_ref4) {
      var query = _ref4.query,
          documentId = _ref4.documentId,
          tags = _ref4.tags;

      if (tags && tags.length > 0) {
        console.warn("search-ui-site-search-connector: Site Search does not support tags on click");
      }

      this._get("analytics/pc", {
        t: new Date().getTime(),
        q: query,
        doc_id: documentId
      });
    }
  }, {
    key: "onAutocompleteResultClick",
    value: function onAutocompleteResultClick(_ref5) {
      var query = _ref5.query,
          documentId = _ref5.documentId,
          tags = _ref5.tags;

      if (tags) {
        console.warn("search-ui-site-search-connector: Site Search does not support tags on autocompleteClick");
      }

      this._get("analytics/pas", {
        t: new Date().getTime(),
        q: query,
        doc_id: documentId
      });
    }
  }, {
    key: "onSearch",
    value: function onSearch(requestState, queryConfig) {
      var _this = this;

      var options = adaptRequest(requestState, queryConfig, this.documentType);
      return this.beforeSearchCall(options, function (newOptions) {
        return _this.request("POST", "engines/search.json", newOptions).then(function (json) {
          return adaptResponse(json, _this.documentType);
        });
      });
    }
  }, {
    key: "onAutocomplete",
    value: function onAutocomplete(_ref6, queryConfig) {
      var searchTerm = _ref6.searchTerm;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this2 = this;

        var options;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!queryConfig.results) {
                  _context.next = 3;
                  break;
                }

                options = adaptRequest({
                  searchTerm: searchTerm
                }, queryConfig.results, this.documentType);
                return _context.abrupt("return", this.beforeAutocompleteResultsCall(options, function (newOptions) {
                  return _this2.request("POST", "engines/suggest.json", newOptions).then(function (json) {
                    return {
                      autocompletedResults: adaptResponse(json, _this2.documentType).results
                    };
                  });
                }));

              case 3:
                if (queryConfig.suggestions) {
                  console.warn("search-ui-site-search-connector: Site Search does support query suggestions on autocomplete");
                }

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }]);

  return SiteSearchAPIConnector;
}();

export default SiteSearchAPIConnector;